import "./App.css";
import { Route, Routes } from "react-router-dom";
import Drawer from "./components/Drawer";
import Home from "./pages/Home/Home";
import Login from "./pages/LoginRegister/Login";
import Register from "./pages/LoginRegister/Register";
import AboutUs from "./pages/AboutUs/AboutUs";
import Shop from "./pages/Shop/Shop";
import Blog from "./pages/Blog/Blog";
import RequireAuth from "./utilities/RequireAuth/RequireAuth";
import ProductDetails1 from "./components/ProductDetails/ProductDetails1";
import DashboardDrawer from "./components/DashboardDrawer";
import MyProfile from "./pages/DashboardPagesShared/MyProfile";
import ManageAllOrders from "./pages/DashboardPagesAdmin/ManageAllOrders";
import RequireAuthAndAdmin from "./utilities/RequireAuth/RequireAuthAndAdmin";
import ManageProducts from "./pages/DashboardPagesAdmin/ManageProducts";
import MakeAdmin from "./pages/DashboardPagesAdmin/MakeAdmin";
import AddAProduct from "./pages/DashboardPagesAdmin/AddAProduct";
import MyWishlist from "./pages/DashBoardPagesUser/MyWishlist";
import MyOrders from "./pages/DashBoardPagesUser/MyOrders";
import AddReview from "./pages/DashBoardPagesUser/AddReview";
import EditMyProfile from "./pages/DashboardPagesShared/EditMyProfile";
import NotFound from "./shared/NotFound";
import BlogDetails from "./components/BlogCard/BlogDetails";
import MyPortfolio from "./pages/MyPortfolio/MyPortfolio";
import ManageDiscount from "./pages/DashboardPagesAdmin/ManageDiscount";
import AddDiscount from "./pages/DashboardPagesAdmin/AddDiscount";
import Cart from "./pages/DashBoardPagesUser/Cart";
import CheckOut from "./pages/DashBoardPagesUser/CheckOut";
import { useState } from "react";

function App() {
  const [changes, setChanges] = useState(0);
  const handleChanges = (data) => {
    setChanges(data);
  };

  return (
    <div className="relative">
      <Routes>
        <Route
          path="*"
          element={
            <Drawer handleChanges={handleChanges} changes={changes}>
              <NotFound></NotFound>
            </Drawer>
          }
        ></Route>
        <Route
          path="/"
          element={
            <Drawer handleChanges={handleChanges} changes={changes}>
              <Home></Home>
            </Drawer>
          }
        ></Route>
        <Route
          path="/login"
          element={
            <Drawer handleChanges={handleChanges} changes={changes}>
              <Login></Login>
            </Drawer>
          }
        ></Route>
        <Route
          path="/register"
          element={
            <Drawer handleChanges={handleChanges} changes={changes}>
              <Register></Register>
            </Drawer>
          }
        ></Route>
        <Route
          path="/about"
          element={
            <Drawer handleChanges={handleChanges} changes={changes}>
              <AboutUs></AboutUs>
            </Drawer>
          }
        ></Route>
        <Route
          path="/shop"
          element={
            <Drawer handleChanges={handleChanges} changes={changes}>
              <Shop></Shop>
            </Drawer>
          }
        ></Route>
        <Route
          path="/contact"
          element={
            <Drawer handleChanges={handleChanges} changes={changes}>
              <MyPortfolio></MyPortfolio>
            </Drawer>
          }
        ></Route>
        <Route
          path="/blog"
          element={
            <Drawer handleChanges={handleChanges} changes={changes}>
              <Blog></Blog>
            </Drawer>
          }
        ></Route>
        <Route
          path="/readBlogs"
          element={
            <Drawer handleChanges={handleChanges} changes={changes}>
              <BlogDetails></BlogDetails>
            </Drawer>
          }
        ></Route>

        <Route
          path="/purchase"
          element={
            <Drawer handleChanges={handleChanges} changes={changes}>
              <ProductDetails1
                changes={changes}
                handleChanges={handleChanges}
              ></ProductDetails1>
            </Drawer>
          }
        ></Route>

        <Route
          path="/my-account"
          element={
            <Drawer handleChanges={handleChanges} changes={changes}>
              <RequireAuth>
                <MyProfile></MyProfile>
              </RequireAuth>
            </Drawer>
          }
        ></Route>
        <Route
          path="/my-account-update"
          element={
            <Drawer handleChanges={handleChanges} changes={changes}>
              <RequireAuth>
                <EditMyProfile></EditMyProfile>
              </RequireAuth>
            </Drawer>
          }
        ></Route>
        {/* user */}
        <Route
          path="/my-wishlist"
          element={
            <Drawer handleChanges={handleChanges} changes={changes}>
              <RequireAuth>
                <MyWishlist></MyWishlist>
              </RequireAuth>
            </Drawer>
          }
        ></Route>
        <Route
          path="/my-orders"
          element={
            <Drawer handleChanges={handleChanges} changes={changes}>
              <RequireAuth>
                <MyOrders></MyOrders>
              </RequireAuth>
            </Drawer>
          }
        ></Route>
        <Route
          path="/my-reviews"
          element={
            <Drawer handleChanges={handleChanges} changes={changes}>
              <RequireAuth>
                <AddReview></AddReview>
              </RequireAuth>
            </Drawer>
          }
        ></Route>

        <Route
          path="/my-cart"
          element={
            <Drawer handleChanges={handleChanges} changes={changes}>
              <RequireAuth>
                <Cart changes={changes} handleChanges={handleChanges}></Cart>
              </RequireAuth>
            </Drawer>
          }
        ></Route>
        <Route
          path="/checkout"
          element={
            <Drawer handleChanges={handleChanges} changes={changes}>
              <RequireAuth>
                <CheckOut
                  changes={changes}
                  handleChanges={handleChanges}
                ></CheckOut>
              </RequireAuth>
            </Drawer>
          }
        ></Route>

        <Route
          path="/dashboard"
          element={
            <Drawer handleChanges={handleChanges} changes={changes}>
              <RequireAuthAndAdmin>
                <DashboardDrawer></DashboardDrawer>
              </RequireAuthAndAdmin>
            </Drawer>
          }
        >
          {/* shared */}
          <Route index element={<ManageAllOrders></ManageAllOrders>}></Route>

          {/* admin  */}
          <Route
            path="manage-orders"
            element={<ManageAllOrders></ManageAllOrders>}
          ></Route>
          <Route
            path="manage-add-product"
            element={<AddAProduct></AddAProduct>}
          ></Route>
          <Route
            path="manage-products"
            element={<ManageProducts></ManageProducts>}
          ></Route>
          <Route path="manage-admin" element={<MakeAdmin></MakeAdmin>}></Route>
          <Route
            path="manage-discount"
            element={<ManageDiscount></ManageDiscount>}
          ></Route>
          <Route
            path="add-discount"
            element={<AddDiscount></AddDiscount>}
          ></Route>
          <Route path="*" element={<NotFound></NotFound>}></Route>
        </Route>
      </Routes>
    </div>
  );
}

export default App;
